import React from 'react'

import { tr } from 'pmt-modules/i18n'

import map from 'lodash/map'

import Diet from './Diet'
import Allergen from './Allergen'
import Gender from './Gender'

import Celery from 'pmt-ui/svg-icons/food/celery'
import Cheese from 'pmt-ui/svg-icons/food/cheese'
import Crab from 'pmt-ui/svg-icons/food/crab'
import Egg from 'pmt-ui/svg-icons/food/egg'
import Fish from 'pmt-ui/svg-icons/food/fish'
import Lupine from 'pmt-ui/svg-icons/food/lupine'
import Milk from 'pmt-ui/svg-icons/food/milk'
import Mustard from 'pmt-ui/svg-icons/food/mustard'
import Nut from 'pmt-ui/svg-icons/food/nut'
import Peanut from 'pmt-ui/svg-icons/food/peanuts'
import Shellfish from 'pmt-ui/svg-icons/food/shellfish'
import Sesame from 'pmt-ui/svg-icons/food/sesame'
import Soy from 'pmt-ui/svg-icons/food/soy'
import Sulphites from 'pmt-ui/svg-icons/food/sulphites'
import Wheat from 'pmt-ui/svg-icons/food/wheat'
import Tartrazine from 'pmt-ui/svg-icons/food/tartrazine'
import Rice from 'pmt-ui/svg-icons/food/rice'
import RedMeat from 'pmt-ui/svg-icons/food/red_meat'
import PoultryMeat from 'pmt-ui/svg-icons/food/poultry_meat'
import Fruit from 'pmt-ui/svg-icons/food/fruit'
import Corn from 'pmt-ui/svg-icons/food/corn'
import Garlic from 'pmt-ui/svg-icons/food/garlic'
import Balsam from 'pmt-ui/svg-icons/food/balsam'
import Buckwheat from 'pmt-ui/svg-icons/food/buckwheat'

export { default as Allergen } from './Allergen'
export { default as Diet } from './Diet'
export { default as Gender } from './Gender'

export const DEFAULT_BIRTHDATE = -2208988800000

//
//
//

export const getGenderLabel = gender => {
  switch (gender) {
    case 0:
      return tr('global.gender.NONE')
    case 1:
      return tr('global.gender.MALE')
    case 2:
      return tr('global.gender.FEMALE')

    default:
      return gender
  }
}

export const getGenderOptions = () =>
  map(Gender, gender => ({
    value: gender,
    label: getGenderLabel(gender),
  }))

//
//
//

export const getDietLabel = diet => {
  switch (diet) {
    case Diet.NONE:
      return tr('global.diet.NONE')
    case Diet.KOSHER:
      return tr('global.diet.KOSHER')
    case Diet.HALAL:
      return tr('global.diet.HALAL')
    case Diet.VEGETARIAN:
      return tr('global.diet.VEGETARIAN')
    case Diet.VEGAN:
      return tr('global.diet.VEGAN')
    default:
      return diet
  }
}

export const getDietsOptions = () =>
  map(Diet, diet => ({
    value: diet,
    label: getDietLabel(diet),
  }))

//
//
//

export const getAllergenLabel = allergen => {
  switch (allergen) {
    case Allergen.BALSAM_OF_PERU:
      return tr('global.allergen.BALSAM_OF_PERU')
    case Allergen.BUCKWHEAT:
      return tr('global.allergen.BUCKWHEAT')
    case Allergen.CELERY:
      return tr('global.allergen.CELERY')
    case Allergen.CHEESE:
      return tr('global.allergen.CHEESE')
    case Allergen.CORN:
      return tr('global.allergen.CORN')
    case Allergen.CRUSTACEAN:
      return tr('global.allergen.CRUSTACEAN')
    case Allergen.EGG:
      return tr('global.allergen.EGG')
    case Allergen.FISH:
      return tr('global.allergen.FISH')
    case Allergen.FRUIT:
      return tr('global.allergen.FRUIT')
    case Allergen.GARLIC:
      return tr('global.allergen.GARLIC')
    case Allergen.LACTOSE:
      return tr('global.allergen.LACTOSE')
    case Allergen.LUPINE:
      return tr('global.allergen.LUPINE')
    case Allergen.MUSTARD:
      return tr('global.allergen.MUSTARD')
    case Allergen.PEANUT:
      return tr('global.allergen.PEANUT')
    case Allergen.POULTRY_MEAT:
      return tr('global.allergen.POULTRY_MEAT')
    case Allergen.RED_MEAT:
      return tr('global.allergen.RED_MEAT')
    case Allergen.RICE:
      return tr('global.allergen.RICE')
    case Allergen.SESAME:
      return tr('global.allergen.SESAME')
    case Allergen.SHELLFISH:
      return tr('global.allergen.SHELLFISH')
    case Allergen.SOYA:
      return tr('global.allergen.SOYA')
    case Allergen.SULPHITES:
      return tr('global.allergen.SULPHITES')
    case Allergen.TARTRAZINE:
      return tr('global.allergen.TARTRAZINE')

    case Allergen.GLUTEN:
      return tr('global.allergen.GLUTEN')
    case Allergen.GLUTEN_OATS:
      return tr('global.allergen.GLUTEN_OATS')
    case Allergen.GLUTEN_WHEAT:
      return tr('global.allergen.GLUTEN_WHEAT')
    case Allergen.GLUTEN_KAMUT:
      return tr('global.allergen.GLUTEN_KAMUT')
    case Allergen.GLUTEN_SPELT:
      return tr('global.allergen.GLUTEN_SPELT')
    case Allergen.GLUTEN_GREEN_SPELT:
      return tr('global.allergen.GLUTEN_GREEN_SPELT')
    case Allergen.GLUTEN_EINKORN:
      return tr('global.allergen.GLUTEN_EINKORN')
    case Allergen.GLUTEN_RYE:
      return tr('global.allergen.GLUTEN_RYE')
    case Allergen.GLUTEN_BARLEY:
      return tr('global.allergen.GLUTEN_BARLEY')
    case Allergen.GLUTEN_EMMER:
      return tr('global.allergen.GLUTEN_EMMER')
    case Allergen.GLUTEN_TRITICALE:
      return tr('global.allergen.GLUTEN_TRITICALE')

    case Allergen.NUTS:
      return tr('global.allergen.NUTS')
    case Allergen.NUTS_ALMONDS:
      return tr('global.allergen.NUTS_ALMONDS')
    case Allergen.NUTS_HAZELNUTS:
      return tr('global.allergen.NUTS_HAZELNUTS')
    case Allergen.NUTS_WALNUTS:
      return tr('global.allergen.NUTS_WALNUTS')
    case Allergen.NUTS_CASHEW:
      return tr('global.allergen.NUTS_CASHEW')
    case Allergen.NUTS_PECANS:
      return tr('global.allergen.NUTS_PECANS')
    case Allergen.NUTS_BRAZIL:
      return tr('global.allergen.NUTS_BRAZIL')
    case Allergen.NUTS_PISTACHES:
      return tr('global.allergen.NUTS_PISTACHES')
    case Allergen.NUTS_MACADAMIA_OR_QUEENSLAND:
      return tr('global.allergen.NUTS_MACADAMIA_OR_QUEENSLAND')

    default:
      return allergen
  }
}

export const getAllergenIcon = allergen => {
  switch (allergen) {
    case Allergen.BALSAM_OF_PERU:
      return <Balsam />
    case Allergen.BUCKWHEAT:
      return <Buckwheat />
    case Allergen.CELERY:
      return <Celery />
    case Allergen.CHEESE:
      return <Cheese />
    case Allergen.CORN:
      return <Corn />
    case Allergen.CRUSTACEAN:
      return <Crab />
    case Allergen.EGG:
      return <Egg />
    case Allergen.FISH:
      return <Fish />
    case Allergen.FRUIT:
      return <Fruit />
    case Allergen.GARLIC:
      return <Garlic />
    case Allergen.LACTOSE:
      return <Milk />
    case Allergen.LUPINE:
      return <Lupine />
    case Allergen.MUSTARD:
      return <Mustard />
    case Allergen.PEANUT:
      return <Peanut />
    case Allergen.POULTRY_MEAT:
      return <PoultryMeat />
    case Allergen.RED_MEAT:
      return <RedMeat />
    case Allergen.RICE:
      return <Rice />
    case Allergen.SESAME:
      return <Sesame />
    case Allergen.SHELLFISH:
      return <Shellfish />
    case Allergen.SOYA:
      return <Soy />
    case Allergen.SULPHITES:
      return <Sulphites />
    case Allergen.TARTRAZINE:
      return <Tartrazine />

    case Allergen.GLUTEN:
      return <Wheat />
    case Allergen.GLUTEN_OATS:
      return <Wheat />
    case Allergen.GLUTEN_WHEAT:
      return <Wheat />
    case Allergen.GLUTEN_KAMUT:
      return <Wheat />
    case Allergen.GLUTEN_SPELT:
      return <Wheat />
    case Allergen.GLUTEN_GREEN_SPELT:
      return <Wheat />
    case Allergen.GLUTEN_EINKORN:
      return <Wheat />
    case Allergen.GLUTEN_RYE:
      return <Wheat />
    case Allergen.GLUTEN_BARLEY:
      return <Wheat />
    case Allergen.GLUTEN_EMMER:
      return <Wheat />
    case Allergen.GLUTEN_TRITICALE:
      return <Wheat />

    case Allergen.NUTS:
      return <Nut />
    case Allergen.NUTS_ALMONDS:
      return <Nut />
    case Allergen.NUTS_HAZELNUTS:
      return <Nut />
    case Allergen.NUTS_WALNUTS:
      return <Nut />
    case Allergen.NUTS_CASHEW:
      return <Nut />
    case Allergen.NUTS_PECANS:
      return <Nut />
    case Allergen.NUTS_BRAZIL:
      return <Nut />
    case Allergen.NUTS_PISTACHES:
      return <Nut />
    case Allergen.NUTS_MACADAMIA_OR_QUEENSLAND:
      return <Nut />

    default:
      return null
  }
}

export const getAllergensOptions = () =>
  map(Allergen, allergen => ({
    value: allergen,
    label: getAllergenLabel(allergen),
    icon: getAllergenIcon(allergen),
  }))

//
//
//

export const DEFAULT_DIETARY_PREFERENCES = {
  diet: Diet.NONE,
  allergens: [],
}
